const isMobileUrl = (href) => {
  const regx = /^\/mobile/;
  return regx.test(href);
};

const isMobile = () => {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag ? true : false;
};

const downloadBase64File = (base64Data, fileName) => {
  const link = document.createElement('a');
  link.href = base64Data;
  link.download = fileName || 'download';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export {
  isMobile,
  isMobileUrl,
  downloadBase64File,
}


// WEBPACK FOOTER //
// ./src/utils/tool.js